module.exports = __webpack_public_path__ + "img/v40.ca401186.jpg";